import { all, takeEvery, put, call, select } from "redux-saga/effects";
import actions from "./actions";
import profileActions from "../profile/actions";
import * as services from "./services";

const getProfileState = (state) => state.profile;

export function* GET_RECEIVED_CREDITZ() {
  const { currentUser } = yield select(getProfileState);
  yield put({
    type: actions.SET_STATE,
    payload: { loading: true },
  });
  // set music hidden
  const notifications = yield call(services.getNotifications, currentUser.uid);
  const posts = [];
  for (let i = 0; i < notifications.length; i++) {
    const notf = notifications[i];
    if (notf.postID && notf.type === 4 && notf.status !== 3) {
      const post = yield call(services.getPost, notf.postID);
      const sender = yield call(services.getSender, post.uid);
      posts.push({ notification: notf, post, sender });
    }
  }
  yield put({
    type: actions.SET_STATE,
    payload: { loading: false, creditz: posts },
  });
  yield put({
    type: profileActions.GET_CURRENT_USER,
    payload: { uid: currentUser.uid },
  });
}

export function* CREATE_VIDEO_CREDITZ({ payload }) {
  const { currentUser } = yield select(getProfileState);
  const { additionalRoles = [], data } = payload;
  yield put({
    type: actions.SET_STATE,
    payload: { loading: true },
  });
  const newCreditz = yield call(
    services.createVideoCreditz,
    currentUser.uid,
    {...data, creditors: additionalRoles}
  );

  for (let i = 0; i < additionalRoles.length; i++) {
    const dt = {
      postID: newCreditz.id,
      status: 0,
      type: 4,
      uid: currentUser.uid,
    };
    yield call(
      services.createNewNotification,
      additionalRoles[i].userId,
      dt
    );
  }
  yield put({
    type: actions.SET_STATE,
    payload: { loading: false, newCreditz, newCreditzCreated: true, additionalRoles },
  });
  yield put({
    type: profileActions.GET_CURRENT_USER,
    payload: {uid: currentUser.uid}
  })
}

export function* UPDATE_NOTIFICATION({payload}) {
  const { currentUser } = yield select(getProfileState);
  yield put({
    type: actions.SET_STATE,
    payload: { loading: true },
  });
  // set music hidden
  yield call(services.updateNotification, currentUser.uid, payload.notifId, payload.status);
  yield put({
    type: actions.GET_RECEIVED_CREDITZ
  })
}


export default function* rootSaga() {
  yield all([
    takeEvery(actions.GET_RECEIVED_CREDITZ, GET_RECEIVED_CREDITZ),
    takeEvery(actions.CREATE_VIDEO_CREDITZ, CREATE_VIDEO_CREDITZ),
    takeEvery(actions.UPDATE_NOTIFICATION, UPDATE_NOTIFICATION),
  ]);
}
